import { api } from 'api/api';
import { AccountContext } from 'components/AccountContext';
import { useEffect, useState, useRef, useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const ENDPOINT =
  process.env.REACT_APP_ENVIRONMENT === 'production'
    ? process.env.REACT_APP_BASE_URL_API_SERVER_PROD
    : process.env.REACT_APP_BASE_URL_API_SERVER_TEST;

const useModelSelecaoPacientes = ({ assinante, titular }) => {
  const state = useLocation();
  const navigate = useNavigate();
  const [modalPaciente, setModalPaciente] = useState(false);
  const { titulo, tipo } = state.state || {};
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [dependentes, setDependentes] = useState([]);
  const { user } = useContext(AccountContext);

  async function fetchPacientes() {
    try {
      if (user.loggedIn === false) return;
      const id_contrato = titular ? user?.id_contrato : user?.id_contrato_dependent?.paciente_contrato_id;
      setError(null);
      setLoading(true);
      await api(`${ENDPOINT}/pacientes/${titular}/${assinante}/${id_contrato}/${user.cpf}`, {
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
      })
        .then(async (res) => {
          return res.json();
        })
        .then(async (resposta) => {
          setError(null);
          setDependentes(resposta);
        });
    } catch (error) {
      setError('Erro ao carregar os pacientes. Por favor, tente novamente mais tarde.');
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    let ignore = false;
    if (!ignore) {
      fetchPacientes();
    }
    return () => {
      ignore = true;
    };
  }, []);

  const handleNavigate = () => {
    if (tipo === 'telepet') {
      navigate('/aviso-pre-atendimento/', {
        state: { titulo: 'Telemedicina Pet', tela: '/telepet/termos/', pediatra: false },
      });
      return;
    }

    if (tipo === 'pediatra') {
      navigate('/medico-agora/', {
        state: { especialista: true, segunda_consulta: true },
      });
      return;
    }

    if (tipo === 'pronto') {
      navigate('/medico-agora/', {
        state: { especialista: true, segunda_consulta: true },
      });
      return;
    }

    if (tipo === 'especialista') {
      navigate('/especialidades');
      return;
    }
  };

  return {
    titulo,
    navigate,
    modalPaciente,
    setModalPaciente,
    error,
    loading,
    dependentes,
    handleNavigate,
  };
};

export default useModelSelecaoPacientes;
